// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_js_partials_dropdown-menu_js":1,"resources_js_partials_go-top_js":1,"resources_js_partials_tooltip_js":1}[chunkId]) return "js/site/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};